import { render } from "./Profile.vue?vue&type=template&id=ced23842&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=ced23842&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ced23842"],['__file',"src/views/Profile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ced23842"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ced23842', __exports__)) {
    api.reload('ced23842', __exports__)
  }
  
  module.hot.accept("./Profile.vue?vue&type=template&id=ced23842&scoped=true", () => {
    api.rerender('ced23842', render)
  })

}


export default __exports__